import styled from 'styled-components';

export default styled('div')`
  display: flex;
  width: 100%;
  padding: 11px 0;
  padding-top: ${({ paddingTop }) => paddingTop || 11}px;
  padding-bottom: ${({ paddingBottom }) => paddingBottom || 11}px;
`;
